import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { differenceInYears, differenceInMonths, differenceInDays } from 'date-fns';
import messages from './ProfilePage.messages';

const MainInformation = ({ name, date, isEditMode, changeHandler, initialRole = '' }) => {
  const { formatMessage } = useIntl();
  const [userRole, setUserRole] = useState(initialRole);

  useEffect(() => {
    setUserRole(initialRole);
  }, [initialRole]);

  const handleStatusChange = e => {
    const newValue = e.target.value;
    setUserRole(newValue);

    // Update Redux draft when value changes
    if (changeHandler) {
      changeHandler('professionalRole', newValue);
    }
  };

  const formatDateJoined = dateJoined => {
    const joinedDate = new Date(dateJoined);
    const now = new Date();

    const yearsDifference = differenceInYears(now, joinedDate);
    if (yearsDifference >= 1) {
      return formatMessage(messages.timeWithUsYears, {
        count: yearsDifference,
      });
    }

    const monthsDifference = differenceInMonths(now, joinedDate);
    if (monthsDifference >= 1) {
      return formatMessage(messages.timeWithUsMonths, {
        count: monthsDifference,
      });
    }

    const daysDifference = differenceInDays(now, joinedDate);
    return formatMessage(messages.timeWithUsDays, {
      count: daysDifference,
    });
  };

  if (isEditMode) {
    return (
      <>
        <label
          htmlFor="user_status"
          className="tw-text-[16px] tw-font-medium tw-mb-2 md:tw-mb-3 xl:tw-mb-2"
        >
          {formatMessage(messages.userProfession)}
        </label>
        <input
          type="text"
          id="user_status"
          value={userRole}
          onChange={handleStatusChange}
          className="input-text tw-w-full tw-pl-4 tw-border-none"
          placeholder="UI/UX дизайнерка"
        />
      </>
    );
  }

  return (
    <>
      <h3 className="tw-text-2xl tw-font-medium tw-text-neutral-1000 tw-leading-[120%] tw-mb-3 md:tw-text-[22px] md:tw-mb-4 xl:tw-text-[28px]">
        {name}
      </h3>
      <p className="tw-text-[16px] font-medium leading-[24px]">{formatDateJoined(date)}</p>
      {userRole && (
        <p className="tw-text-[16px] font-medium leading-[24px] tw-mt-2 md:tw-mt-3">{userRole}</p>
      )}
    </>
  );
};

MainInformation.propTypes = {
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
  changeHandler: PropTypes.func,
  initialRole: PropTypes.string,
};

MainInformation.defaultProps = {
  isEditMode: false,
  changeHandler: null,
  initialRole: '',
  name: '',
};

export default MainInformation;
